import { render, staticRenderFns } from "./GoodsStock.vue?vue&type=template&id=d85a175c&scoped=true&"
import script from "./GoodsStock.vue?vue&type=script&lang=js&"
export * from "./GoodsStock.vue?vue&type=script&lang=js&"
import style0 from "./GoodsStock.vue?vue&type=style&index=0&id=d85a175c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a175c",
  null
  
)

export default component.exports